/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs */

const es_marketplace_seo_galicia_guide_mussels_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barco mejillones en Galicia`)
};

const gl_marketplace_seo_galicia_guide_mussels_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barco mexillóns en Galicia`)
};

const en_marketplace_seo_galicia_guide_mussels_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mussel boat tour in Galicia`)
};

/**
* | output |
* | --- |
* | "Mussel boat tour in Galicia" |
*
* @param {Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_mussels_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Mussels_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_mussels_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_mussels_title(inputs)
	return es_marketplace_seo_galicia_guide_mussels_title(inputs)
});